module.exports = __webpack_public_path__ + "1791188489487/images/mastercard2.478335a.png";